import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { Routes, Route, Navigate } from "react-router-dom";

import Cart from "./pages/Cart";
import Home from "./pages/Home";
import Login from "./pages/Login";
import Product from "./pages/Product";
import ProductList from "./pages/ProductList";
import Register from "./pages/Register";
import Success from "./pages/Success";
import { loadUser } from "./redux/userRedux";

const App = () => {
  // const user = useSelector((state) => state.user.currentUser);
  const dispatch = useDispatch();

  // console.log(user);

  useEffect(() => {
    dispatch(loadUser(null));
  }, [dispatch]);

  console.log(localStorage.getItem("token"));

  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/products" element={<ProductList />} />
      <Route path="/products/:category" element={<ProductList />} />
      <Route path="/product/:id" element={<Product />} />
      <Route path="/cart" element={<Cart />} />
      <Route
        path="/login"
        element={
          localStorage.getItem("token") ? (
            <Navigate to="/" replace />
          ) : (
            <Login />
          )
        }
      />
      <Route
        path="/register"
        element={
          localStorage.getItem("token") ? (
            <Navigate to="/" replace />
          ) : (
            <Register />
          )
        }
      />
      <Route path="/success" element={<Success />} />
      <Route
        path="*"
        element={<Navigate to="/" replace />} //this is a way to redirect
      />
    </Routes>
  );
};

export default App;
